/**
 * Holds tab style buttons, has scrollbar when buttons overflow screen
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const TabContainer = ({children}) => {

    return (
        <div className="flex flex-row my-8 overflow-auto martrak-scroll-container" >
            {children}

            {/* add div to take up extra space to extend the border across the screen */}
            <div style={{borderBottom: "1px solid #ddd", flex: 1}}></div>
        </div>
    );
};
